var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import classNames from "classnames";
import require$$0, { createContext, useState, useEffect, useContext, useRef, forwardRef, useImperativeHandle } from "react";
import { UniRequest } from "@uniframe/toolkit";
import Cookie from "js-cookie";
import Toast from "toastify-js";
import Monitor from "@fe/monitor";
import { API2_HOST } from "by-dynamic-domain";
import { Input, Tooltip, Button as Button$1, Modal } from "@bfe/moly";
import DOMPurify from "dompurify";
import CryptoJS from "crypto-js";
import "js-sha256";
(function(window2) {
  if (typeof window2 === "undefined") {
    throw new Error("Geetest requires browser environment");
  }
  var document2 = window2.document;
  var Math2 = window2.Math;
  var head = document2.getElementsByTagName("head")[0];
  function _Object(obj) {
    this._obj = obj;
  }
  _Object.prototype = {
    _each: function(process) {
      var _obj = this._obj;
      for (var k2 in _obj) {
        if (_obj.hasOwnProperty(k2)) {
          process(k2, _obj[k2]);
        }
      }
      return this;
    }
  };
  function Config(config) {
    var self = this;
    new _Object(config)._each(function(key, value) {
      self[key] = value;
    });
  }
  Config.prototype = {
    api_server: "api.geetest.com",
    protocol: "http://",
    typePath: "/gettype.php",
    fallback_config: {
      slide: {
        static_servers: ["static.geetest.com", "dn-staticdown.qbox.me"],
        type: "slide",
        slide: "/static/js/geetest.0.0.0.js"
      },
      fullpage: {
        static_servers: ["static.geetest.com", "dn-staticdown.qbox.me"],
        type: "fullpage",
        fullpage: "/static/js/fullpage.0.0.0.js"
      }
    },
    _get_fallback_config: function() {
      var self = this;
      if (isString(self.type)) {
        return self.fallback_config[self.type];
      } else if (self.new_captcha) {
        return self.fallback_config.fullpage;
      } else {
        return self.fallback_config.slide;
      }
    },
    _extend: function(obj) {
      var self = this;
      new _Object(obj)._each(function(key, value) {
        self[key] = value;
      });
    }
  };
  var isNumber = function(value) {
    return typeof value === "number";
  };
  var isString = function(value) {
    return typeof value === "string";
  };
  var isBoolean = function(value) {
    return typeof value === "boolean";
  };
  var isObject = function(value) {
    return typeof value === "object" && value !== null;
  };
  var isFunction = function(value) {
    return typeof value === "function";
  };
  var MOBILE = /Mobi/i.test(navigator.userAgent);
  var pt = MOBILE ? 3 : 0;
  var callbacks = {};
  var status = {};
  var nowDate = function() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (day >= 0 && day <= 9) {
      day = "0" + day;
    }
    if (hours >= 0 && hours <= 9) {
      hours = "0" + hours;
    }
    if (minutes >= 0 && minutes <= 9) {
      minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
      seconds = "0" + seconds;
    }
    var currentdate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
    return currentdate;
  };
  var random = function() {
    return parseInt(Math2.random() * 1e4) + new Date().valueOf();
  };
  var loadScript2 = function(url, cb) {
    var script = document2.createElement("script");
    script.charset = "UTF-8";
    script.async = true;
    if (/static\.geetest\.com/g.test(url)) {
      script.crossOrigin = "anonymous";
    }
    script.onerror = function() {
      cb(true);
    };
    var loaded = false;
    script.onload = script.onreadystatechange = function() {
      if (!loaded && (!script.readyState || "loaded" === script.readyState || "complete" === script.readyState)) {
        loaded = true;
        setTimeout(function() {
          cb(false);
        }, 0);
      }
    };
    script.src = url;
    head.appendChild(script);
  };
  var normalizeDomain = function(domain) {
    return domain.replace(/^https?:\/\/|\/$/g, "");
  };
  var normalizePath = function(path) {
    path = path.replace(/\/+/g, "/");
    if (path.indexOf("/") !== 0) {
      path = "/" + path;
    }
    return path;
  };
  var normalizeQuery = function(query) {
    if (!query) {
      return "";
    }
    var q2 = "?";
    new _Object(query)._each(function(key, value) {
      if (isString(value) || isNumber(value) || isBoolean(value)) {
        q2 = q2 + encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
      }
    });
    if (q2 === "?") {
      q2 = "";
    }
    return q2.replace(/&$/, "");
  };
  var makeURL = function(protocol, domain, path, query) {
    domain = normalizeDomain(domain);
    var url = normalizePath(path) + normalizeQuery(query);
    if (domain) {
      url = protocol + domain + url;
    }
    return url;
  };
  var load = function(config, send, protocol, domains, path, query, cb) {
    var tryRequest = function(at) {
      var url = makeURL(protocol, domains[at], path, query);
      loadScript2(url, function(err) {
        if (err) {
          if (at >= domains.length - 1) {
            cb(true);
            if (send) {
              config.error_code = 508;
              var url2 = protocol + domains[at] + path;
              reportError(config, url2);
            }
          } else {
            tryRequest(at + 1);
          }
        } else {
          cb(false);
        }
      });
    };
    tryRequest(0);
  };
  var jsonp = function(domains, path, config, callback) {
    if (isObject(config.getLib)) {
      config._extend(config.getLib);
      callback(config);
      return;
    }
    if (config.offline) {
      callback(config._get_fallback_config());
      return;
    }
    var cb = "geetest_" + random();
    window2[cb] = function(data) {
      if (data.status == "success") {
        callback(data.data);
      } else if (!data.status) {
        callback(data);
      } else {
        callback(config._get_fallback_config());
      }
      window2[cb] = void 0;
      try {
        delete window2[cb];
      } catch (e) {
      }
    };
    load(
      config,
      true,
      config.protocol,
      domains,
      path,
      {
        gt: config.gt,
        callback: cb
      },
      function(err) {
        if (err) {
          callback(config._get_fallback_config());
        }
      }
    );
  };
  var reportError = function(config, url) {
    load(
      config,
      false,
      config.protocol,
      ["monitor.geetest.com"],
      "/monitor/send",
      {
        time: nowDate(),
        captcha_id: config.gt,
        challenge: config.challenge,
        pt,
        exception_url: url,
        error_code: config.error_code
      },
      function(err) {
      }
    );
  };
  var throwError = function(errorType, config) {
    var errors = {
      networkError: "\u7F51\u7EDC\u9519\u8BEF",
      gtTypeError: "gt\u5B57\u6BB5\u4E0D\u662F\u5B57\u7B26\u4E32\u7C7B\u578B"
    };
    if (typeof config.onError === "function") {
      config.onError(errors[errorType]);
    } else {
      throw new Error(errors[errorType]);
    }
  };
  var detect = function() {
    return window2.Geetest || document2.getElementById("gt_lib");
  };
  if (detect()) {
    status.slide = "loaded";
  }
  window2.initGeetest = function(userConfig, callback) {
    var config = new Config(userConfig);
    if (userConfig.https) {
      config.protocol = "https://";
    } else if (!userConfig.protocol) {
      config.protocol = window2.location.protocol + "//";
    }
    if (userConfig.gt === "050cffef4ae57b5d5e529fea9540b0d1" || userConfig.gt === "3bd38408ae4af923ed36e13819b14d42") {
      config.apiserver = "yumchina.geetest.com/";
      config.api_server = "yumchina.geetest.com";
    }
    if (userConfig.gt) {
      window2.GeeGT = userConfig.gt;
    }
    if (userConfig.challenge) {
      window2.GeeChallenge = userConfig.challenge;
    }
    if (isObject(userConfig.getType)) {
      config._extend(userConfig.getType);
    }
    jsonp(
      [config.api_server || config.apiserver],
      config.typePath,
      config,
      function(newConfig) {
        var type = newConfig.type;
        var init = function() {
          config._extend(newConfig);
          callback(new window2.Geetest(config));
        };
        callbacks[type] = callbacks[type] || [];
        var s = status[type] || "init";
        if (s === "init") {
          status[type] = "loading";
          callbacks[type].push(init);
          load(
            config,
            true,
            config.protocol,
            newConfig.static_servers || newConfig.domains,
            newConfig[type] || newConfig.path,
            null,
            function(err) {
              if (err) {
                status[type] = "fail";
                throwError("networkError", config);
              } else {
                status[type] = "loaded";
                var cbs = callbacks[type];
                for (var i = 0, len = cbs.length; i < len; i = i + 1) {
                  var cb = cbs[i];
                  if (isFunction(cb)) {
                    cb();
                  }
                }
                callbacks[type] = [];
              }
            }
          );
        } else if (s === "loaded") {
          init();
        } else if (s === "fail") {
          throwError("networkError", config);
        } else if (s === "loading") {
          callbacks[type].push(init);
        }
      }
    );
  };
})(window);
var index$5 = "";
var index$4 = "";
var index$3 = "";
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = require$$0, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, g) {
  var b, d = {}, e = null, h = null;
  void 0 !== g && (e = "" + g);
  void 0 !== a.key && (e = "" + a.key);
  void 0 !== a.ref && (h = a.ref);
  for (b in a)
    m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      void 0 === d[b] && (d[b] = a[b]);
  return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
}
reactJsxRuntime_production_min.Fragment = l;
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
const globalContext = createContext({});
const Provider = globalContext.Provider;
globalContext.displayName = "safeGlobalProvider";
const GlobalProvider = ({
  children,
  value
}) => {
  const [localLang, setLocalLang] = useState(value.lang || "en");
  useEffect(() => {
    if (value == null ? void 0 : value.lang) {
      setLocalLang(value == null ? void 0 : value.lang);
    }
  }, [value, value == null ? void 0 : value.lang, value == null ? void 0 : value.$t]);
  const reloadPage = () => {
    window.location.reload();
  };
  let className = "by-security-iconfont";
  if ((value == null ? void 0 : value.lang.toLowerCase()) === "ar-sa") {
    className += "ar-sa-security";
  }
  return /* @__PURE__ */ jsx(Provider, {
    value: {
      $t: value == null ? void 0 : value.$t,
      lang: localLang,
      setLocalLang,
      reloadCallBack: (value == null ? void 0 : value.reloadCallBack) || reloadPage
    },
    children: /* @__PURE__ */ jsx("div", {
      className,
      children
    })
  });
};
function useStore() {
  return useContext(globalContext);
}
const Mobile = () => {
  return /* @__PURE__ */ jsxs("svg", {
    t: "1697700068436",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "9872",
    width: "16",
    height: "16",
    fill: "#81858C",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M426.666667 725.333333a42.666667 42.666667 0 1 0 0 85.333334h170.666666a42.666667 42.666667 0 1 0 0-85.333334h-170.666666z",
      "p-id": "9873"
    }), /* @__PURE__ */ jsx("path", {
      d: "M298.666667 42.666667a170.666667 170.666667 0 0 0-170.666667 170.666666v597.333334a170.666667 170.666667 0 0 0 170.666667 170.666666h426.666666a170.666667 170.666667 0 0 0 170.666667-170.666666V213.333333a170.666667 170.666667 0 0 0-170.666667-170.666666H298.666667zM213.333333 213.333333a85.333333 85.333333 0 0 1 85.333334-85.333333h426.666666a85.333333 85.333333 0 0 1 85.333334 85.333333v597.333334a85.333333 85.333333 0 0 1-85.333334 85.333333H298.666667a85.333333 85.333333 0 0 1-85.333334-85.333333V213.333333z",
      "p-id": "9874"
    })]
  });
};
const Mail = () => {
  return /* @__PURE__ */ jsx("svg", {
    t: "1697699989796",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "9425",
    width: "16",
    height: "16",
    fill: "#81858C",
    children: /* @__PURE__ */ jsx("path", {
      d: "M213.333333 170.666667a128 128 0 0 0-128 128v426.666666a128 128 0 0 0 128 128h597.333334a128 128 0 0 0 128-128V298.666667a128 128 0 0 0-128-128H213.333333zM170.666667 309.333333l315.477333 236.629334c15.36 11.477333 36.394667 11.477333 51.712 0L853.333333 309.333333V725.333333a42.666667 42.666667 0 0 1-42.666666 42.666667H213.333333a42.666667 42.666667 0 0 1-42.666666-42.666667V309.333333zM782.208 256L512 458.666667 241.792 256h540.416z",
      "p-id": "9426"
    })
  });
};
const FundPassword = () => {
  return /* @__PURE__ */ jsx("svg", {
    t: "1697700001793",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "9574",
    width: "16",
    height: "16",
    fill: "#81858C",
    children: /* @__PURE__ */ jsx("path", {
      d: "M341.333333 341.333333v42.666667h341.333334V341.333333a170.666667 170.666667 0 0 0-341.333334 0zM256 384V341.333333a256 256 0 1 1 512 0v42.666667h42.666667a128 128 0 0 1 128 128v298.666667a128 128 0 0 1-128 128H213.333333a128 128 0 0 1-128-128v-298.666667a128 128 0 0 1 128-128h42.666667z m-42.666667 85.333333a42.666667 42.666667 0 0 0-42.666666 42.666667v298.666667a42.666667 42.666667 0 0 0 42.666666 42.666666h597.333334a42.666667 42.666667 0 0 0 42.666666-42.666666v-298.666667a42.666667 42.666667 0 0 0-42.666666-42.666667H213.333333z m341.333334 197.034667V725.333333a42.666667 42.666667 0 1 1-85.333334 0v-58.965333a64 64 0 1 1 85.333334 0z",
      "p-id": "9575"
    })
  });
};
const Google2fa = () => {
  return /* @__PURE__ */ jsx("svg", {
    t: "1697700019686",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "9723",
    width: "16",
    height: "16",
    fill: "#81858C",
    children: /* @__PURE__ */ jsx("path", {
      d: "M964.352 426.837333a42.666667 42.666667 0 0 0-41.984-35.072H520.533333a42.666667 42.666667 0 0 0-42.666666 42.666667v165.034667a42.666667 42.666667 0 0 0 42.666666 42.666666h169.045334c-12.032 20.309333-28.544 37.632-48.256 50.645334a215.893333 215.893333 0 0 1-120.789334 33.536 210.56 210.56 0 0 1-198.229333-146.688v-0.085334a209.237333 209.237333 0 0 1 0-135.125333v-0.085333A210.602667 210.602667 0 0 1 520.533333 297.728a186.794667 186.794667 0 0 1 133.589334 51.925333 42.666667 42.666667 0 0 0 59.690666-0.64l122.368-122.368a42.666667 42.666667 0 0 0-1.066666-61.397333A453.290667 453.290667 0 0 0 520.533333 42.666667a467.2 467.2 0 0 0-419.370666 258.517333l-0.042667 0.085333A466.005333 466.005333 0 0 0 51.2 512a472.704 472.704 0 0 0 49.92 210.773333l0.042667 0.042667A467.2 467.2 0 0 0 520.533333 981.333333a449.109333 449.109333 0 0 0 311.253334-114.645333l0.042666-0.042667a460.202667 460.202667 0 0 0 140.970667-344.917333c0-31.829333-2.816-63.573333-8.448-94.890667zM520.533333 128a370.474667 370.474667 0 0 1 222.250667 71.381333l-62.037333 61.994667A275.754667 275.754667 0 0 0 520.533333 212.394667a293.845333 293.845333 0 0 0-255.573333 151.466666L219.392 328.533333l-24.96-19.370666A381.994667 381.994667 0 0 1 520.533333 128zM157.013333 635.861333a385.28 385.28 0 0 1 0-247.722666l76.032 58.965333a292.437333 292.437333 0 0 0 0 129.792l-76.074666 58.965333zM520.533333 896a381.952 381.952 0 0 1-326.144-181.162667l16.170667-12.544 54.442667-42.24a293.76 293.76 0 0 0 255.530666 151.594667 310.485333 310.485333 0 0 0 141.056-32.042667l72.149334 56.021334A379.264 379.264 0 0 1 520.533333 896z m278.442667-117.76l-7.808-6.101333-58.752-45.610667a239.189333 239.189333 0 0 0 59.733333-119.253333 42.666667 42.666667 0 0 0-41.984-50.474667H563.2v-79.701333h322.090667c1.450667 14.72 2.176 29.653333 2.176 44.629333a386.218667 386.218667 0 0 1-88.490667 256.469333z",
      "p-id": "9724"
    })
  });
};
const ByShowTips = ({
  verifyType,
  number,
  theme
}) => {
  const {
    $t
  } = useStore();
  return /* @__PURE__ */ jsx("div", {
    className: classNames(["by-security-user-behaviour-title"]),
    children: verifyType === "payment_password_verify" ? /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("span", {
        className: classNames(["by-security-use-icon"]),
        children: /* @__PURE__ */ jsx(FundPassword, {})
      }), /* @__PURE__ */ jsx("span", {
        children: $t("fundPassword")
      })]
    }) : verifyType === "phone_verify" ? /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("span", {
        className: classNames(["by-security-use-icon"]),
        children: /* @__PURE__ */ jsx(Mobile, {})
      }), /* @__PURE__ */ jsxs("span", {
        className: "by-security-user-behaviour-title-text",
        children: [$t("VerificationCodeWillSendTo"), /* @__PURE__ */ jsx("span", {
          className: "security-item-value",
          children: number
        })]
      })]
    }) : verifyType === "email_verify" ? /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("span", {
        className: classNames(["by-security-use-icon"]),
        children: /* @__PURE__ */ jsx(Mail, {})
      }), /* @__PURE__ */ jsxs("span", {
        className: "by-security-user-behaviour-title-text",
        children: [$t("VerificationCodeWillSendTo"), /* @__PURE__ */ jsx("span", {
          className: "security-item-value",
          children: number
        })]
      })]
    }) : /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("span", {
        className: classNames(["by-security-use-icon"]),
        children: /* @__PURE__ */ jsx(Google2fa, {})
      }), /* @__PURE__ */ jsx("span", {
        children: $t("Google verification code")
      })]
    })
  });
};
var index$2 = "";
const getLang = () => {
  const lang = window.localStorage.getItem("BYBIT_LANG_KEY") || navigator.language;
  return lang === "en" ? "en" : lang;
};
function getResourceMap(hostname) {
  let env = "cht-test-5";
  let domain = "bybit";
  let domainType = "com";
  let IS_NEW_TAB2 = false;
  const domainList = ["www", "m", "testnet", "m-testnet"];
  const hostSplits = hostname.split(".");
  if (hostSplits.length === 3) {
    [env, domain, domainType] = hostSplits;
    if (!domainList.some((domain2) => domain2 === env)) {
      IS_NEW_TAB2 = true;
    }
    if (env.includes("testnet")) {
      env = "testnet";
    } else {
      env = "www";
    }
  }
  if (hostSplits.length === 4) {
    [, env, domain, domainType] = hostSplits;
  }
  const envReg = /^(www|m)$/;
  const isProdReg = /^(www|m|testnet|m-testnet)$/;
  const isTestnet = env === "testnet" || env === "m-testnet";
  const cdnStaticProd = "s1.bycsi.com";
  const cdnStatic = isTestnet ? "t1.bycsi.com" : cdnStaticProd;
  const isProd = isProdReg.test(env);
  const isLocalNet = !envReg.test(env);
  const notTestnet = isLocalNet && !isTestnet;
  const BYBIT_DOMAIN = isProd ? `.${domain}.${domainType}` : `.${env}.${domain}.${domainType}`;
  const JUMP_DOMAIN2 = isTestnet || isProd ? `${window.location.protocol}//${env}.${domain}.${domainType}` : ``;
  let api2ServicePrefix = `api2.${isLocalNet ? `${env}.` : ""}`;
  let api2ServicePrefixActivity = `actapi.${isLocalNet ? `${env}.` : ""}`;
  let ws2ServicePrefix = `ws2.${isLocalNet ? `${env}.` : ""}`;
  let affiliateServicePrefix = `affiliate.${isLocalNet ? `${env}.` : ""}`;
  let affiliatesPrefix = `affiliates.${isLocalNet ? `${env}.` : ""}`;
  let pcDomain = hostname.replace(/^m./, "www.");
  let mobileDomain = hostname.replace(/^www./, "m.");
  let chatDomain = hostname.replace(/www./, "chat.");
  if (isTestnet) {
    api2ServicePrefix = "api2-testnet.";
    api2ServicePrefixActivity = "actapi-testnet.";
    ws2ServicePrefix = "ws2-testnet.";
    affiliateServicePrefix = "affiliate-testnet.";
    affiliatesPrefix = "affiliates-testnet.";
    pcDomain = hostname.replace(/^m-testnet./, "testnet.");
    mobileDomain = hostname.replace(/^testnet./, "m-testnet.");
    if (chatDomain.indexOf("chat-") === -1)
      chatDomain = `chat-${chatDomain}`;
  }
  let tmsPath = "";
  if (notTestnet) {
    tmsPath = "https://tms.ffe390afd658c19dcbf707e0597b846d.de";
  }
  return {
    isProd,
    ZENDESK_HOST: `help.${domain}.com`,
    DOMAIN: domain,
    DOMAIN_TYPE: domainType,
    TOKEN_COOKIE_KEY: `b_t_c_k${envReg.test(env) ? "" : `_${env}`}`,
    API2_HOST: `//${api2ServicePrefix}${domain}.${domainType}`,
    API2_HOST_ACTIVITY: `//${api2ServicePrefixActivity}${domain}.${domainType}`,
    WS2_HOST: `wss://${ws2ServicePrefix}${domain}.${domainType}`,
    APP_HOST: `//app.${domain}.${domainType}`,
    TMS_HOST: tmsPath,
    BLOG_HOST: `blog.${domain}.com`,
    AFFILIATE_HOST: `//${affiliateServicePrefix}${domain}.${domainType}`,
    AFFILIATES_HOST: `https://${affiliatesPrefix}${domain}.${domainType}`,
    CDN_STATIC_HOST: `https://${cdnStaticProd}`,
    CDN_STATIC: `https://${cdnStatic}`,
    CDN_STATIC_OLD: `https://static.${domain}.com`,
    CDN_STATIC_OLD_HOST: `static.${domain}.com`,
    CDN_STATIC_OLD_TESTNET_HOST: `static-testnet.${domain}.com`,
    PC_HOST: `//${pcDomain}`,
    MOBILE_HOST: `//${mobileDomain}`,
    CHAT_DOMAIN: `//${chatDomain}`,
    BYBIT_DOMAIN,
    JUMP_DOMAIN: JUMP_DOMAIN2,
    IS_NEW_TAB: IS_NEW_TAB2
  };
}
const mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const tabletRE = /android|ipad|playbook|silk/i;
function isMobile$2(opts) {
  if (!opts)
    opts = {};
  let ua = opts.ua;
  if (!ua && typeof navigator !== "undefined")
    ua = navigator.userAgent;
  if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") {
    ua = ua.headers["user-agent"];
  }
  if (typeof ua !== "string")
    return false;
  let result = mobileRE.test(ua) || !!opts.tablet && tabletRE.test(ua);
  if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf("Macintosh") !== -1 && ua.indexOf("Safari") !== -1) {
    result = true;
  }
  return result;
}
const BYBIT_GUID_KEY = "_by_l_g_d";
const platform = isMobile$2() ? "h5" : "pc";
const BYBIT_TOKEN_COOKIE_KEY = getResourceMap(
  window.location.hostname
).TOKEN_COOKIE_KEY;
const cookieDomain = getResourceMap(
  window.location.hostname
).BYBIT_DOMAIN;
const JUMP_DOMAIN = getResourceMap(window.location.hostname).JUMP_DOMAIN;
const IS_NEW_TAB = getResourceMap(window.location.hostname).IS_NEW_TAB;
function s4() {
  return Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
}
function generateGuid() {
  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}
function getGuid() {
  let guid = Cookie.get(BYBIT_GUID_KEY);
  if (!guid || guid.length !== 36) {
    guid = generateGuid();
  }
  Cookie.set(BYBIT_GUID_KEY, guid, {
    expires: 120,
    path: "/",
    domain: cookieDomain
  });
  return guid;
}
const monitor = new Monitor({
  name: "safety_component"
});
const listenError = (log) => {
  try {
    monitor.log(log);
  } catch (e) {
  }
};
const EVENT_LIMIT_TIME = 5e3;
const request = new UniRequest({ responseType: "json" });
class ByError extends Error {
  constructor() {
    super(...arguments);
    __publicField(this, "data", null);
  }
}
const defaultErrorHandler = () => {
};
const defaultOption = {
  "Content-Type": "application/json;charset=UTF-8",
  Accept: "application/json"
};
const fetchData = (url, options = { headers: {} }) => {
  var _a;
  let fetchUrl = url;
  if (options.body && (!options.method || options.method === "GET")) {
    const bodyData = JSON.parse(options.body);
    const queryParams = Object.keys(bodyData).map(
      (key) => `${key}=${encodeURIComponent(bodyData[key])}`
    );
    fetchUrl = `${url}?${queryParams.join("&")}`;
    delete options.body;
  }
  let userToken;
  let guid;
  let lang;
  userToken = Cookie.get(BYBIT_TOKEN_COOKIE_KEY);
  guid = getGuid();
  lang = (_a = getLang()) != null ? _a : "en";
  const mergedOptions = __spreadProps(__spreadValues({
    credentials: "include"
  }, options), {
    headers: __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, defaultOption), {
      platform
    }), options.headers), {
      UserToken: (userToken === "null" ? "" : userToken) || "",
      Guid: guid,
      Lang: lang === "en" ? "en" : lang
    })
  });
  return new Promise((resolve, reject) => {
    var _a2, _b;
    const starTime = new Date().getTime();
    const method = (_b = (_a2 = mergedOptions.method) == null ? void 0 : _a2.toLowerCase()) != null ? _b : "get";
    request[method](fetchUrl, mergedOptions).then((resp) => {
      const { errorHandler } = options;
      if (resp.status >= 400) {
        const handler = errorHandler || defaultErrorHandler;
        handler(resp);
        return null;
      }
      return resp.data;
    }).then((data) => {
      var _a3, _b2, _c;
      const { ret_code, ret_msg, token } = data || {};
      const endTime = new Date().getTime();
      if (endTime - starTime > EVENT_LIMIT_TIME) {
        listenError({
          t: "error",
          ajax_url: fetchUrl,
          errorType: "overtime",
          timeCount: 5e3,
          link: window.location.href
        });
      }
      if (typeof token !== "undefined" && token !== null && token !== "null") {
        Cookie.set(BYBIT_TOKEN_COOKIE_KEY, token, {
          expires: 7,
          path: "/",
          domain: cookieDomain
        });
      }
      let isError = ret_code === 0 && typeof ((_a3 = data.result) == null ? void 0 : _a3.ret_code) === "number" && ((_b2 = data.result) == null ? void 0 : _b2.ret_code) > 1e4;
      if (!(ret_code === void 0) && ret_code !== 0 && ret_code !== 10007 || isError) {
        let error_code = ret_code;
        if (isError) {
          error_code = (_c = data.result) == null ? void 0 : _c.ret_code;
        }
        const error = new ByError(ret_msg);
        error.data = { ret_code: error_code, ret_msg };
        const errorData = { error, data };
        throw errorData;
      }
      resolve(data);
    }).catch((e) => {
      var _a3, _b2;
      if (((_a3 = e == null ? void 0 : e.response) == null ? void 0 : _a3.status) === 403) {
        listenError({
          t: "error",
          ajax_url: fetchUrl,
          errorType: "band-limited-403",
          timeCount: 5e3,
          link: window.location.href
        });
      }
      if (!e || !e.data) {
        reject({ ret_code: -200, ret_msg: e, poz: 2 });
        return;
      }
      let { ret_code, ret_msg } = e.data;
      if (ret_code === 0) {
        ret_code = (_b2 = e.data.result) == null ? void 0 : _b2.ret_code;
      }
      if (ret_code === 10007 || ret_code === 33003 || ret_code === 10009) {
        Cookie.set(BYBIT_TOKEN_COOKIE_KEY, "", {
          expires: 7,
          path: "/",
          domain: cookieDomain
        });
        reject(e);
        return;
      }
      if (ret_code === 20065 || ret_code === 20064) {
        reject(e);
        return;
      }
      if (40423 === ret_code) {
        reject({ ret_code });
        setTimeout(() => {
          window.location.reload();
        }, 3e3);
      }
      !mergedOptions.hideError && Toast({
        text: `${ret_code}: ${ret_msg}`,
        duration: 5e3,
        position: "center",
        close: false,
        className: "by-security-iconfont  by-security-auto-toast by-security-auto-toast--error"
      }).showToast();
      if (ret_code) {
        reject(e);
      } else {
        reject({ ret_code: -200, ret_msg: e, poz: 3 });
      }
    });
  });
};
fetchData.get = (url, options) => fetchData(url, __spreadProps(__spreadValues({}, options), {
  method: "GET"
}));
fetchData.post = (url, options) => fetchData(url, __spreadProps(__spreadValues({}, options), {
  method: "POST"
}));
fetchData.put = (url, options) => fetchData(url, __spreadProps(__spreadValues({}, options), {
  method: "PUT"
}));
fetchData.delete = (url, options) => fetchData(url, __spreadProps(__spreadValues({}, options), {
  method: "DELETE"
}));
const host = { "NODE_ENV": "production" }.HOST || window.location.host;
const wsptc = window.location.protocol.replace(/^http/, "ws");
const reg = /^(.*?\.){0,}(.*?)\.([\w\-]{1,}?)\.(com|cn|io|org|net)/;
const match = reg.exec(host);
const [, , m2, m4] = match || [];
m2 && m2.indexOf("testnet") > -1;
window.location.host.replace(/^www|m|testnet/, "");
if (host.indexOf("www.") !== -1) {
  `//${host.replace(/www./, "api2.")}`;
  `${wsptc}//${host.replace(/www./, "ws2.")}`;
  `//${host.replace(/www./, "whale.")}`;
  `//${host.replace(/www./, "chat.")}`;
}
const apiUrl = API2_HOST;
const baseUrl$1 = localStorage.getItem("testApi") || apiUrl;
function registerGeetest(name) {
  return __async(this, null, function* () {
    return yield fetchData.get(
      `${baseUrl$1}/v3/public/user/captcha-info`,
      {
        body: JSON.stringify({
          type: "CAPTCHA_TYPE_BEHAVIOR_GEETEST",
          login_name: name
        }),
        hideError: true
      }
    );
  });
}
function riskSendCode(params) {
  return fetchData.post(
    `${baseUrl$1}/user/public/risk/send/code`,
    {
      body: JSON.stringify(params),
      hideError: false
    }
  );
}
const jumpSecurityFindItem = () => {
  const lang = localStorage.BYBIT_LANG_KEY || "en";
  const _url = "/" + lang + "/security-item-find";
  if (IS_NEW_TAB) {
    window.open(JUMP_DOMAIN + _url, "_blank");
  } else {
    window.location.href = JUMP_DOMAIN + _url;
  }
};
const App = ({
  $t,
  theme,
  lastEl,
  step,
  compIds,
  compId
}) => {
  if (compIds.includes("google2fa")) {
    if (compId === "payment_password_verify")
      return "";
  }
  const pathName = window.location.pathname;
  if (["/app/user/security-item-find", "/app/user/retrieve"].includes(pathName) || pathName.indexOf("/security-item-find") > -1 || window.location.origin.indexOf("3001") > 0) {
    return /* @__PURE__ */ jsx("div", {
      style: {
        height: "24px"
      }
    });
  }
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx("div", {
      className: classNames(["by-safety-google2fa-text-button by-safety-pos-r", lastEl && step !== 3 ? "last-element" : ""]),
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx("span", {
        onClick: () => {
          jumpSecurityFindItem();
        },
        children: $t("SecurityVerificationNotAvailable")
      })
    })
  });
};
const ByVerificationLongInput = ({
  refType,
  step,
  theme,
  verifyType,
  riskToken,
  number,
  isShowTime,
  value,
  isShowErrorName,
  hiddenUnBindGoogleText,
  singleValidationItem,
  useNewSecurityVerificationNotAvailable,
  getInputChange,
  onEmailResend,
  onPhoneResend,
  verifyHaveGoogle,
  onChange,
  onGoogleTips
}) => {
  const inputEl = useRef(null);
  const [displayTimer, setTimer] = useState(60);
  const [btnDisabled, setDisabled] = useState(false);
  const [isShowResendCode, setIsShowResendCode] = useState(false);
  const [values, setValue] = useState("");
  useState(false);
  const [isClick, setIsClick] = useState(true);
  const {
    $t
  } = useStore();
  const handleChange = (e) => {
    const val = e.target.value;
    if (val.length <= 6) {
      setValue(val);
      getInputChange == null ? void 0 : getInputChange(val, verifyType);
      onChange == null ? void 0 : onChange(val);
    } else {
      const lastVal = val.substring(val.length - 1);
      const newVal = values.substring(0, values.length - 1) + lastVal;
      setValue(newVal);
      getInputChange == null ? void 0 : getInputChange(newVal, verifyType);
      onChange == null ? void 0 : onChange(newVal);
    }
  };
  const fundPasswordChange = (e) => {
    const val = e.target.value;
    if (val.length <= 30) {
      setValue(val);
      getInputChange == null ? void 0 : getInputChange(val, verifyType);
      onChange == null ? void 0 : onChange(val);
    } else {
      const lastVal = val.substring(val.length - 1);
      const newVal = values.substring(0, values.length - 1) + lastVal;
      setValue(newVal);
      getInputChange == null ? void 0 : getInputChange(newVal, verifyType);
      onChange == null ? void 0 : onChange(newVal);
    }
  };
  const handSendClick = (e) => {
    var _a;
    if (e && typeof e !== "string")
      e == null ? void 0 : e.preventDefault();
    (_a = inputEl == null ? void 0 : inputEl.current) == null ? void 0 : _a.focus();
    if (e === void 0) {
      return;
    }
    if (btnDisabled) {
      return;
    }
    if (riskToken) {
      getRiskSendCode(verifyType);
      return;
    }
    if (verifyType === "email_verify") {
      onEmailResend == null ? void 0 : onEmailResend(() => {
        resendTime();
      });
    } else if (verifyType === "phone_verify") {
      onPhoneResend == null ? void 0 : onPhoneResend(() => {
        resendTime();
      });
    }
  };
  const getRiskSendCode = (component_id) => __async(void 0, null, function* () {
    try {
      if (isClick) {
        setIsClick(false);
        const res = yield riskSendCode({
          risk_token: riskToken || "",
          component_id
        });
        if (res.ret_code === 0) {
          if (res.result.cool_down > 0) {
            Toast({
              text: $t("VerifyCodeSendFrequently"),
              duration: 5e3,
              position: false,
              className: "by-security-iconfont  by-security-auto-toast by-security-auto-toast--error"
            }).showToast();
            setIsClick(true);
            return;
          } else {
            resendTime();
          }
        }
        setIsClick(true);
      }
    } catch (err) {
      setIsClick(true);
    }
  });
  const resendTime = () => {
    let resendTimer = 60;
    setDisabled(true);
    setIsShowResendCode(true);
    const timer = setInterval(() => {
      resendTimer -= 1;
      if (resendTimer <= 0) {
        clearInterval(timer);
        resendTimer = 60;
        setTimer(60);
        setDisabled(false);
      } else {
        setTimer(resendTimer);
      }
    }, 1e3);
  };
  useEffect(() => {
    if (step === 1 && singleValidationItem) {
      handSendClick("init");
    }
    return () => {
    };
  }, []);
  useEffect(() => {
    if (verifyType === "email_verify" && isShowTime) {
      resendTime();
    } else if (verifyType === "phone_verify" && isShowTime) {
      resendTime();
    }
  }, [isShowTime]);
  useEffect(() => {
    if (value === null) {
      setValue("");
      getInputChange == null ? void 0 : getInputChange("", verifyType);
    }
  }, [value]);
  useEffect(() => {
    if (inputEl.current) {
      inputEl.current.value = "";
    }
  }, [inputEl]);
  const ResetBtn = () => verifyType === "google2fa" || verifyType === "payment_password_verify" ? null : /* @__PURE__ */ jsx("div", {
    onClick: handSendClick,
    className: classNames(["by-safety-reset-btn"], {
      "by-safety-btn-disabled": btnDisabled
    }),
    "aria-hidden": "true",
    children: btnDisabled ? displayTimer + "s" : isShowResendCode ? `${$t("registerResend")}` : `${$t("Send verification code")}`
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "by-safety-ui",
    children: [/* @__PURE__ */ jsx(ByShowTips, {
      number,
      verifyType,
      theme
    }), verifyType === "payment_password_verify" ? /* @__PURE__ */ jsx(Input, {
      style: {
        marginTop: "8px"
      },
      "auto-complete": "new-password",
      autoComplete: "new-password",
      type: "password",
      visible: true,
      allowClear: true,
      onChange: fundPasswordChange,
      ref: inputEl,
      value: values,
      placeholder: $t("pleaseEnterFundPassword")
    }) : /* @__PURE__ */ jsx(Input, {
      maxLength: 6,
      firstZero: true,
      type: "number",
      numberControl: false,
      style: {
        marginTop: "8px"
      },
      onChange: handleChange,
      ref: inputEl,
      suffix: /* @__PURE__ */ jsx(ResetBtn, {}),
      placeholder: verifyType === "email_verify" ? $t("pleaseEnterEmailVerificationCode") : verifyType === "phone_verify" ? $t("pleaseEnterTheMobileVerificationCode") : $t("pleaseEnterGoogleVerificationCode")
    }), refType && verifyType === "google2fa" && /* @__PURE__ */ jsx(App, {
      compId: "google2fa",
      compIds: ["google2fa"],
      $t,
      step: 1,
      lastEl: true,
      theme
    })]
  });
};
function useVerificationInput({
  disabledProps,
  getInputChange,
  onChange,
  verifyType,
  value
}) {
  const inputRefList = useRef([]);
  const getInputRef = (input) => {
    inputRefList.current.push(input);
  };
  const curIdx = useRef(0);
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [disabled, setDisabled] = useState(false);
  const handleFocus = (index2) => () => {
    var _a, _b;
    if (index2 === 0) {
      curIdx.current = 0;
      if (((_a = inputRefList.current[index2]) == null ? void 0 : _a.value) === "") {
        return;
      }
    } else {
      if ((_b = inputRefList.current[index2]) == null ? void 0 : _b.value) {
        curIdx.current = index2;
        return;
      } else {
        curIdx.current = index2;
      }
      if (inputRefList.current[index2 - 1].value === "") {
        inputRefList.current[index2 - 1].focus();
      }
    }
  };
  const focusMoveBack = (index2) => {
    if (index2 < 5) {
      inputRefList.current[index2 + 1].focus();
    } else {
      inputRefList.current[index2].focus();
    }
  };
  const inputValueChange = (target, item, index2, google2fa) => {
    if (inputRefList.current[index2].value.length === 1 || inputRefList.current[index2].value.length === 2) {
      const newCode = code.slice(0);
      if (target.value.split("").filter((val) => val === item).length === 2) {
        newCode[index2] = item;
        setCode(newCode);
      } else {
        newCode[index2] = target.value.split("").filter((val) => val !== item)[0];
        setCode(newCode);
      }
      google2fa.val = newCode.join("");
      focusMoveBack(index2);
    }
  };
  const handleDisable = (google2faVal, focusIndex) => {
    getInputChange == null ? void 0 : getInputChange(google2faVal, verifyType);
    onChange == null ? void 0 : onChange(google2faVal);
  };
  const handleInput = (item, index2) => (e) => {
    const target = e.target;
    if (item.length === 0) {
      const newCode = code.slice(0);
      newCode[index2] = target.value;
      setCode(newCode);
    }
    curIdx.current = index2;
    const google2fa = { val: "" };
    inputValueChange(target, item, index2, google2fa);
    onChange == null ? void 0 : onChange(google2fa.val);
    if (google2fa.val.length === 6) {
      handleDisable(google2fa.val);
    }
  };
  const handleDelete = (e) => {
    if (e.keyCode === 8 || e.keyCode === 46) {
      const index2 = curIdx.current;
      const inputValue = inputRefList.current[index2].value;
      const newCode = inputRefList.current.slice(0, 6).map((item) => {
        var _a;
        return (_a = item && item.value) != null ? _a : "";
      });
      if (inputValue) {
        newCode[index2] = "";
        setCode(newCode);
        inputRefList.current[index2].focus();
      } else {
        if (index2 === 0) {
          inputRefList.current[index2].focus();
        } else {
          newCode[index2 - 1] = "";
          setCode(newCode);
          inputRefList.current[index2 - 1].focus();
        }
      }
      if (newCode.length) {
        onChange == null ? void 0 : onChange(newCode.join(""));
        getInputChange == null ? void 0 : getInputChange(newCode.join(""), verifyType);
      }
    }
    if (e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40 || e.keyCode === 69 || e.keyCode === 16 || e.keyCode === 20 || e.keyCode === 190 || e.keyCode === 189 || e.keyCode === 187) {
      e.preventDefault();
    }
  };
  const handlePaste = (e) => {
    var _a;
    e.preventDefault();
    const evt = e;
    if (evt.clipboardData) {
      const data = (_a = evt.clipboardData) == null ? void 0 : _a.getData("text").replace(/\D/g, "");
      if (data.length >= 6) {
        setCode(data.slice(0, 6).split(""));
        handleDisable(data.slice(0, 6));
      } else {
        const len = data.length;
        const joinArr = Array.from(Array(6 - len), () => "");
        setCode(data.split("").concat(joinArr));
      }
    }
  };
  useEffect(() => {
    inputRefList.current = inputRefList.current.splice(-6);
  }, [inputRefList.current]);
  useEffect(() => {
    document.querySelectorAll(".by-safety-verification-input");
    return () => {
      inputRefList.current = [];
    };
  }, []);
  useEffect(() => {
    if (value === null) {
      setCode(["", "", "", "", "", ""]);
      getInputChange == null ? void 0 : getInputChange("", verifyType);
    }
  }, [value]);
  return {
    code,
    disabled,
    getInputRef,
    handleFocus,
    handleInput,
    handlePaste,
    handleDelete
  };
}
function sanitize(dirty) {
  var _a;
  if ((_a = DOMPurify) == null ? void 0 : _a.sanitize)
    return DOMPurify.sanitize(dirty);
  return dirty;
}
const MobileToolTipContent = ({
  verifyType,
  $t,
  number,
  lang = "en"
}) => {
  const aLink = `<a href='/${lang}/help-center/bybitHC_Article/?language=${lang == null ? void 0 : lang.replace("-", "_")}&id=000001036'>`;
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("div", {
      children: $t("tryTheFollowingSteps")
    }), /* @__PURE__ */ jsxs("ul", {
      children: [/* @__PURE__ */ jsxs("li", {
        children: ["\u2022", " ", /* @__PURE__ */ jsx("span", {
          dangerouslySetInnerHTML: {
            __html: sanitize($t("checkYourPhone").replace("{phone}", `<b>${number}</b>`))
          }
        })]
      }), /* @__PURE__ */ jsxs("li", {
        children: ["\u2022 ", $t("clearSmsNotice")]
      }), /* @__PURE__ */ jsxs("li", {
        children: ["\u2022", " ", /* @__PURE__ */ jsx("span", {
          dangerouslySetInnerHTML: {
            __html: sanitize($t("unGetSmSGuide").replace("<a>", aLink))
          }
        })]
      })]
    })]
  });
};
const MailToolTipContent = ({
  $t,
  number = "",
  lang = "en"
}) => {
  const aLink = `<a href='/${lang}/help-center/s/article/Did-Not-Receive-Bybit-s-Email-Inside-My-Email-Inbox-What-Should-I-Do'>`;
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("div", {
      children: $t("tryTheFollowingSteps")
    }), /* @__PURE__ */ jsx("ul", {
      children: /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsxs("li", {
          children: ["\u2022", " ", /* @__PURE__ */ jsx("span", {
            dangerouslySetInnerHTML: {
              __html: sanitize($t("checkYourEmail").replace("{email}", `<b>${number}</b>`))
            }
          })]
        }), /* @__PURE__ */ jsxs("li", {
          children: ["\u2022 ", $t("checkYourJunkMail")]
        }), /* @__PURE__ */ jsxs("li", {
          children: ["\u2022", " ", /* @__PURE__ */ jsx("span", {
            dangerouslySetInnerHTML: {
              __html: sanitize($t("unGetEmailTryIt").replace("<a>", aLink))
            }
          })]
        })]
      })
    })]
  });
};
const ToolTipContent = (props) => {
  const [lang, setLang] = useState(props.lang || "en");
  useEffect(() => {
    var _a, _b;
    if (!props.lang) {
      const htmlLang = (_b = (_a = window == null ? void 0 : window.document) == null ? void 0 : _a.querySelector("html")) == null ? void 0 : _b.lang;
      if (htmlLang) {
        setLang(htmlLang);
      }
    }
    return () => {
    };
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [props.verifyType === "email_verify" && /* @__PURE__ */ jsx(MailToolTipContent, __spreadProps(__spreadValues({}, props), {
      lang
    })), props.verifyType === "phone_verify" && /* @__PURE__ */ jsx(MobileToolTipContent, __spreadProps(__spreadValues({}, props), {
      lang
    }))]
  });
};
function isMobile$1(opts) {
  const mobileRE2 = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
  const tabletRE2 = /android|ipad|playbook|silk/i;
  if (!opts)
    opts = {};
  let ua = opts.ua;
  if (!ua && typeof navigator !== "undefined")
    ua = navigator.userAgent;
  if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") {
    ua = ua.headers["user-agent"];
  }
  if (typeof ua !== "string")
    return false;
  let result = mobileRE2.test(ua) || !!opts.tablet && tabletRE2.test(ua);
  if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf("Macintosh") !== -1 && ua.indexOf("Safari") !== -1) {
    result = true;
  }
  return result;
}
const MiniInput = ({
  values,
  disabled,
  onFocus,
  autoFocus,
  onInput,
  theme,
  isShowErrorName,
  getInputRef,
  handleDelete,
  handlePaste
}) => /* @__PURE__ */ jsx("input", {
  ref: getInputRef,
  className: classNames(["by-safety-verification-input-wrapper-box", isShowErrorName && "by-safety-verification-input-error"]),
  type: "number",
  title: "code",
  maxLength: 1,
  value: values,
  disabled,
  onFocus,
  autoFocus,
  onChange: onInput,
  onPaste: handlePaste,
  onKeyDown: handleDelete
});
const ByVerificationInput = ({
  refType,
  step,
  singleValidationItem,
  lang,
  is_single,
  disabledProps,
  verifyType,
  number,
  type,
  isShowTime,
  theme,
  riskToken,
  value,
  captchaPre,
  isShowErrorName,
  hiddenUnBindGoogleText,
  useNewSecurityVerificationNotAvailable,
  verifyHaveGoogle,
  getInputChange,
  onEmailResend,
  onPhoneResend,
  onChange,
  onGoogleTips
}) => {
  const {
    code,
    disabled,
    handlePaste,
    handleDelete,
    getInputRef,
    handleFocus,
    handleInput
  } = useVerificationInput({
    disabledProps,
    getInputChange,
    onChange,
    verifyType,
    value
  });
  const [displayTimer, setTimer] = useState(60);
  const [mark, setMark] = useState(true);
  const [btnDisabled, setDisabled] = useState(false);
  const [isShowResendCode, setIsShowResendCode] = useState(false);
  const ref = useRef();
  const {
    $t
  } = useStore();
  const handSendClick = (e) => {
    if (e)
      e.preventDefault();
    if (e === void 0 && btnDisabled) {
      return;
    }
    if (riskToken) {
      getRiskSendCode(verifyType);
      return;
    }
    if (verifyType === "email_verify") {
      onEmailResend == null ? void 0 : onEmailResend(() => {
        resendTime();
      });
    } else if (verifyType === "phone_verify") {
      onPhoneResend == null ? void 0 : onPhoneResend(() => {
        resendTime();
      });
    }
  };
  const getRiskSendCode = (component_id) => __async(void 0, null, function* () {
    var _a;
    try {
      if (mark) {
        setMark(false);
        const res = yield riskSendCode({
          risk_token: riskToken || "",
          component_id
        });
        if (res.ret_code === 0) {
          if (((_a = res == null ? void 0 : res.result) == null ? void 0 : _a.cool_down) > 0) {
            Toast({
              text: $t("VerifyCodeSendFrequently"),
              duration: 5e3,
              position: false,
              className: "by-security-iconfont  by-security-auto-toast by-security-auto-toast--error"
            }).showToast();
          } else {
            resendTime();
          }
        }
        setMark(true);
      }
    } catch (e) {
      setMark(true);
    }
  });
  const resendTime = () => {
    let resendTimer = 60;
    setDisabled(true);
    setIsShowResendCode(true);
    console.info("\u5B9A\u65F6\u5668\u8BA1\u65F6");
    const timer = setInterval(() => {
      resendTimer -= 1;
      if (resendTimer <= 0) {
        clearInterval(timer);
        resendTimer = 60;
        setTimer(60);
        setDisabled(false);
      } else {
        setTimer(resendTimer);
      }
    }, 1e3);
  };
  useEffect(() => {
    if (verifyType === "email_verify" && isShowTime && !captchaPre) {
      resendTime();
    } else if (verifyType === "phone_verify" && isShowTime && !captchaPre) {
      resendTime();
    }
  }, []);
  useEffect(() => {
    const is_mobile = isMobile$1();
    return () => {
      if (is_mobile)
        return;
      if (ref == null ? void 0 : ref.current) {
        const width = window.getComputedStyle(ref.current).width;
        const nodeList = document.querySelectorAll(".by-safety-verification-input-wrapper-box");
        const parentList = document.querySelectorAll(".by-safety-verification-input");
        nodeList.forEach((node) => {
          node.style.height = width;
        });
        parentList.forEach((node) => {
          node.style.height = width;
        });
      }
    };
  }, [ref, ref.current]);
  const pathName = window.location.pathname;
  if (pathName === "/app/user/retrieve") {
    hiddenUnBindGoogleText = true;
  }
  useEffect(() => {
    if (["phone_verify", "email_verify"].includes(verifyType) && btnDisabled && displayTimer && type === "mini") {
      if (displayTimer == 60 || displayTimer == 59) {
        document.querySelector(".by-safety-verification-input-wrapper input").focus();
      }
    }
  }, [btnDisabled, displayTimer]);
  useEffect(() => {
    if (type === "mini") {
      if (["phone_verify", "email_verify"].includes(verifyType)) {
        handSendClick();
      }
    }
  }, [type, verifyType, is_single, step]);
  if (pathName === "/app/user/retrieve") {
    hiddenUnBindGoogleText = true;
  }
  return /* @__PURE__ */ jsx("div", {
    className: classNames({
      "security-input-verify-container": refType,
      "security-input-verify-container-google": verifyType === "google2fa"
    }),
    children: type === "mini" ? /* @__PURE__ */ jsxs("div", {
      className: "by-safety-ui",
      children: [/* @__PURE__ */ jsx(ByShowTips, {
        number,
        verifyType,
        theme
      }), /* @__PURE__ */ jsx("div", {
        className: "by-safety-verification-input",
        children: code.map((item, index2) => {
          const childView = /* @__PURE__ */ jsx("div", {
            className: "by-safety-verification-input-wrapper",
            ref,
            children: /* @__PURE__ */ jsx(MiniInput, {
              isShowErrorName,
              getInputRef,
              values: item,
              autoFocus: index2 === 0 ? true : false,
              disabled,
              onFocus: handleFocus(index2),
              onInput: handleInput(item, index2),
              handleDelete,
              handlePaste,
              theme
            })
          }, index2);
          return childView;
        })
      }), verifyType === "google2fa" ? refType && /* @__PURE__ */ jsx(App, {
        compId: "google2fa",
        compIds: ["google2fa"],
        number: "",
        $t,
        step: 1,
        lastEl: true
      }) : /* @__PURE__ */ jsxs("div", {
        className: classNames(["by-safety-pos-r"]),
        "aria-hidden": "true",
        children: [/* @__PURE__ */ jsx(Tooltip, {
          trigger: "click",
          title: /* @__PURE__ */ jsx(ToolTipContent, {
            verifyType,
            lang,
            $t,
            number
          }),
          placement: "bottom",
          zIndex: 10006,
          children: /* @__PURE__ */ jsx("span", {
            className: "unget-verifycode",
            children: $t("unGetVerifyCode")
          })
        }, "tooltips"), /* @__PURE__ */ jsx("span", {
          onClick: handSendClick,
          style: {
            display: "inline-block",
            minWidth: "25px"
          },
          className: classNames("by-safety-reset-color", {
            "by-safety-btn-disabled": btnDisabled
          }),
          children: btnDisabled ? displayTimer + "s" : isShowResendCode ? `${$t("registerResend")}` : `${$t("Send verification code")}`
        })]
      })]
    }) : /* @__PURE__ */ jsx(ByVerificationLongInput, {
      refType,
      step,
      singleValidationItem,
      hiddenUnBindGoogleText,
      useNewSecurityVerificationNotAvailable: true,
      getInputChange,
      onEmailResend,
      verifyHaveGoogle,
      onPhoneResend,
      onChange,
      onGoogleTips,
      isShowErrorName,
      number,
      verifyType,
      isShowTime,
      theme,
      riskToken,
      value
    })
  });
};
var index$1 = "";
const ByUserPanel = ({
  refType,
  theme,
  type,
  verify,
  lang,
  value,
  captchaPre,
  hiddenUnBindGoogleText,
  useNewSecurityVerificationNotAvailable,
  isShowErrorName,
  onEmailResend,
  onPhoneResend,
  onInputChange,
  onChange,
  onGoogleTips
}) => {
  const is_single = verify.length === 1;
  return /* @__PURE__ */ jsx(Fragment, {
    children: verify == null ? void 0 : verify.map((_item) => {
      return /* @__PURE__ */ jsx(ByVerificationInput, {
        refType,
        is_single,
        captchaPre,
        hiddenUnBindGoogleText,
        isShowErrorName,
        theme,
        value,
        number: _item.component_extension || "",
        verifyType: _item.component_id,
        type: type || "",
        isShowTime: _item.isShowTime,
        useNewSecurityVerificationNotAvailable: true,
        getInputChange: onInputChange,
        onEmailResend,
        onPhoneResend,
        onChange,
        onGoogleTips
      }, _item.component_id);
    })
  });
};
const WrapperComp$1 = (obj) => {
  if (!obj.isRoot) {
    return /* @__PURE__ */ jsx(ByUserPanel, __spreadValues({}, obj));
  }
  return /* @__PURE__ */ jsx(GlobalProvider, {
    value: __spreadValues({}, obj),
    children: /* @__PURE__ */ jsx(ByUserPanel, __spreadProps(__spreadValues({}, obj), {
      refType: "verify_input"
    }))
  });
};
function isScriptExist(url) {
  if (typeof url === "string") {
    const scriptsArr = Array.from(document.getElementsByTagName("script"));
    let isExist = false;
    for (let i = 0, len = scriptsArr.length; i < len; i += 1) {
      isExist = scriptsArr[i].src.replace("http:", "https:") === url.replace("http:", "https:");
      if (isExist) {
        break;
      }
    }
    return isExist;
  }
  return false;
}
const loadScript = (options) => {
  if (!options.src)
    return Promise.resolve(false);
  if (options.id) {
    const script = document.querySelector(`script#${options.id}`);
    if (script)
      return Promise.resolve(script);
  }
  return new Promise((resolve) => {
    const parentDom = document.head || document.getElementsByTagName("body")[0];
    const scriptDom = document.createElement("script");
    const attrs = __spreadValues({
      type: "text/javascript",
      async: options.async !== false
    }, options);
    Object.entries(attrs).forEach(([key, value]) => {
      scriptDom.setAttribute(key, `${value}`);
    });
    scriptDom.onload = () => {
      resolve(scriptDom);
    };
    scriptDom.onerror = () => {
      resolve(false);
    };
    scriptDom.src = options.src;
    parentDom.appendChild(scriptDom);
  });
};
function isMobile() {
  const ua = navigator.userAgent;
  const isAndroid = /(?:Android)/.test(ua);
  const isFireFox = /(?:Firefox)/.test(ua);
  const isTablet = /(?:iPad|PlayBook)/.test(ua) || isAndroid && !/(?:Mobile)/.test(ua) || isFireFox && /(?:Tablet)/.test(ua);
  const isIPhone = /(?:iPhone)/.test(ua) && !isTablet;
  return isIPhone || isAndroid;
}
class BaseCaptcha {
  constructor(options = {}) {
    __publicField(this, "key");
    __publicField(this, "captcha");
    __publicField(this, "defaultLang");
    __publicField(this, "lang");
    __publicField(this, "siteKey");
    __publicField(this, "url");
    __publicField(this, "id");
    __publicField(this, "ready");
    __publicField(this, "loaded");
    __publicField(this, "options");
    __publicField(this, "injectFunction");
    __publicField(this, "recaptchaElm");
    this.key = "recaptcha";
    this.captcha = null;
    this.defaultLang = "en";
    this.lang = options.lang || this.defaultLang;
    this.siteKey = "";
    this.id = void 0;
    this.ready = false;
    this.loaded = false;
    this.options = options;
    this.url = void 0;
  }
  resize(el) {
  }
  load() {
    return __async(this, null, function* () {
      if (this.loaded && isScriptExist(this.url)) {
        return true;
      }
      const res = yield loadScript({
        src: this.url,
        async: false
      });
      if (!res) {
        console.warn(`[${this.key}] Script can not load`);
        this.loaded = false;
        return false;
      }
      this.loaded = true;
      return true;
    });
  }
}
const GeetestLocalMap = {
  "en-US": "en",
  en: "en",
  "zh-CN": "zh-cn",
  "zh-TW": "zh-tw",
  "ja-JP": "ja",
  "ru-RU": "ru",
  "es-ES": "es",
  "vi-VN": "vi",
  "tr-TR": "tr",
  "pt-BR": "pt-pt",
  "fr-FR": "fr",
  "th-TH": "th",
  "id-ID": "id",
  "ko-KR": "ko",
  "vi-vn": "vi",
  "kk-KZ": "",
  "fil-PH": "",
  "uk-UA": "",
  "hi-IN": ""
};
class Geetest extends BaseCaptcha {
  constructor(options) {
    super(options);
    __publicField(this, "apiMethod");
    __publicField(this, "successHandler");
    this.successHandler = () => {
    };
    this.key = "geecaptcha";
    this.defaultLang = "en";
    this.apiMethod = options.geetStep1Request;
  }
  setLang(lang) {
    let key = Object.keys(GeetestLocalMap).find((vl) => vl === lang);
    if (key === void 0) {
      key = this.defaultLang;
    }
    this.lang = GeetestLocalMap[key];
  }
  refresh() {
    if (this.captcha && this.captcha.reset) {
      this.captcha.reset();
    }
  }
  destroy() {
    if (this.captcha) {
      this.captcha.destroy();
    }
  }
  initialize(options) {
    return __async(this, null, function* () {
      try {
        const { id, callback } = options;
        let loginHash = "";
        if (!loginHash) {
          loginHash = Cookie.get(BYBIT_GUID_KEY);
          if (!loginHash || loginHash.length !== 36) {
            loginHash = generateGuid();
          }
        }
        const value = CryptoJS.MD5(loginHash);
        const { ret_code, result: data } = yield this.apiMethod(
          value.toString()
        );
        if (!data || ret_code !== 0) {
          throw new Error("Init Error");
        }
        const { gt, challenge, newCaptcha } = data;
        const self = this;
        window.initGeetest(
          {
            gt,
            challenge,
            new_captcha: newCaptcha,
            offline: false,
            lang: self.lang,
            product: "bind",
            hideSuccess: true,
            hideClose: true,
            hideRefresh: true
          },
          (geetCaptcha) => {
            self.captcha = geetCaptcha;
            geetCaptcha.onSuccess(() => {
              const result = geetCaptcha.getValidate();
              self.successHandler && self.successHandler({
                type: self.key,
                geetest_challenge: result.geetest_challenge,
                geetest_validate: result.geetest_validate,
                geetest_seccode: result.geetest_seccode
              });
            });
            geetCaptcha.onError(
              (error) => {
                console.warn(`[${this.key}] ${error}`);
                const code = error.error_code.split("_")[1];
                if (+code > 100) {
                  geetCaptcha.destroy();
                  callback({ type: self.key, fallback: true });
                } else {
                  geetCaptcha.reset();
                  callback({
                    type: self.key,
                    error: error.message || `[${this.key}] InValid`
                  });
                }
              }
            );
          }
        );
        return true;
      } catch (e) {
        console.warn(`[${this.key}] ${e}`);
        return false;
      }
    });
  }
  show(options) {
    return __async(this, null, function* () {
      var _a;
      this.successHandler = options.callback;
      if (!this.captcha || !this.captcha.verify)
        return false;
      (_a = this.captcha) == null ? void 0 : _a.verify();
      return true;
    });
  }
}
const RECAPTCHA_SITE_KEY = "6Lf-PBciAAAAAPt8JcrDsUuM4ocIID0CyPTq6QXq";
const QQ_SITE_KEY = "192668753";
class Qqcaptcha extends BaseCaptcha {
  constructor(options) {
    super(options);
    this.key = "qqcaptcha";
    this.defaultLang = "en";
    this.url = "https://ssl.captcha.qq.com/TCaptcha.js";
    this.siteKey = QQ_SITE_KEY;
  }
  setLang(lang) {
    this.lang = lang || this.defaultLang;
  }
  refresh() {
    this.captcha.destroy();
    this.captcha.show();
  }
  initialize(options) {
    return __async(this, null, function* () {
      if (!this.ready) {
        const loadRes = yield this.load();
        if (!loadRes) {
          return false;
        }
      } else {
        this.ready = true;
      }
      const { id, callback } = options;
      this.id = id;
      const self = this;
      const initPms = new Promise((resolve) => {
        setTimeout(() => {
          resolve(false);
        }, 3e4);
        this.captcha = new window.TencentCaptcha(
          QQ_SITE_KEY,
          (resp) => {
            if (resp.ret === 0) {
              callback({
                type: self.key,
                ticket: resp.ticket,
                randstr: resp.randstr
              });
            } else {
              callback({
                type: self.key,
                error: resp.errorMessage || `[${this.key}] Valid error`
              });
            }
          }
        );
        resolve(true);
      });
      const initRes = yield initPms;
      if (!initRes) {
        console.warn(`[${this.key}] Initialize error`);
      }
      this.ready = true;
      return initRes;
    });
  }
  show(options) {
    return __async(this, null, function* () {
      try {
        const initRes = yield this.initialize(options);
        if (initRes) {
          this.captcha.show();
        }
        return initRes;
      } catch (e) {
        console.warn(`[${this.key}] ${e}`);
        return false;
      }
    });
  }
}
const LocalMap = {
  "en-US": "en",
  en: "en",
  "zh-CN": "zh-CN",
  "zh-MY": "zh-MY",
  "zh-TW": "zh-TW",
  "ja-JP": "ja",
  "ru-RU": "ru",
  "es-ES": "es",
  "vi-VN": "vi",
  "tr-TR": "tr",
  "pt-BR": "pt",
  "fr-FR": "fr",
  "th-TH": "th",
  "id-ID": "id",
  "kk-KZ": "",
  "fil-PH": "fil",
  "uk-UA": "uk",
  "hi-IN": "hi"
};
class Recaptcha extends BaseCaptcha {
  constructor(options) {
    super(options);
    this.key = "recaptcha";
    this.siteKey = RECAPTCHA_SITE_KEY;
    this.defaultLang = "en";
    this.lang = options.lang || this.defaultLang;
    this.injectFunction = null;
    this.setUrl();
  }
  resize(el) {
    let dom;
    if (typeof el === "string") {
      dom = document.querySelector(`#${el}`);
    } else {
      dom = el;
    }
    if (dom) {
      const parent = dom.parentElement;
      if (parent) {
        const scale = parent.clientWidth / 304;
        dom.style.transform = `scale(${scale})`;
      }
    }
  }
  setLang(lang) {
    this.lang = lang || this.defaultLang;
    this.setUrl();
  }
  setUrl() {
    const lang = LocalMap[this.lang] || "en";
    this.url = `https://www.google.com/recaptcha/api.js?render=explicit&hl=${lang}`;
  }
  refresh() {
    try {
      window.grecaptcha && window.grecaptcha.reset();
    } catch (e) {
      console.warn(`[${this.key}] Refresh error`);
    }
  }
  initGContainer(options) {
    const { id, callback, theme } = options;
    this.recaptchaElm = document.createElement("div");
    this.recaptchaElm.id = id;
    this.recaptchaElm.style.position = "fixed";
    this.recaptchaElm.style.top = "75px";
    this.recaptchaElm.dataset.sitekey = this.siteKey;
    document.body.appendChild(this.recaptchaElm);
  }
  render(options) {
    console.info("---- id ----");
    const { id, callback, theme } = options;
    if (!this.recaptchaElm || !document.querySelector(`#${id}`)) {
      this.initGContainer(options);
    }
    this.id = id;
    this.options.invisibleMode ? "invisible" : "normal";
    const self = this;
    const initPms = new Promise((resolve) => {
      setTimeout(() => {
        resolve(false);
      }, 3e4);
      window.grecaptcha.ready(() => {
        self.captcha = window.grecaptcha.render(id, {
          classes: "zs-test",
          sitekey: self.siteKey,
          size: "invisible",
          theme: theme || "light",
          callback(recaptchaToken, abc) {
            if (self == null ? void 0 : self.injectFunction) {
              self == null ? void 0 : self.injectFunction({
                type: self.key,
                g_recaptcha_response: recaptchaToken
              });
            } else {
              callback && callback({ type: self.key, recaptcha: recaptchaToken });
            }
            window.grecaptcha.reset(self.captcha);
          },
          "expired-callback": () => {
            callback({
              type: self.key,
              error: `[${self.key}] ReCAPTCHA expired`
            });
            window.grecaptcha.reset(self.captcha);
          },
          "error-callback": () => {
            callback({
              type: self.key,
              error: `[${self.key}] ReCAPTCHA error`
            });
            window.grecaptcha.reset(self.captcha);
          }
        });
        resolve(true);
      });
    });
    return initPms;
  }
  initialize(options) {
    return __async(this, null, function* () {
      const loadRes = yield this.load();
      if (!loadRes) {
        return false;
      }
      const initRes = yield this.render(options);
      if (!initRes) {
        console.warn(`[${this.key}] Initialize error`);
      }
      this.ready = true;
      return initRes;
    });
  }
  show(options) {
    return __async(this, null, function* () {
      if (options.callback) {
        this.injectFunction = options.callback;
      }
      try {
        if (this.options.invisibleMode && window.grecaptcha) {
          const res2 = yield window.grecaptcha.execute(this.captcha);
          return true;
        }
        const res = yield this.initialize(options);
        if (res) {
          this.show(options);
        }
        return res;
      } catch (e) {
        console.warn(`[${this.key}] ${e}`);
        return false;
      }
    });
  }
}
class PluginLoader {
  constructor(options) {
    __publicField(this, "options");
    __publicField(this, "plugins");
    this.plugins = [];
    this.options = options;
    const _a = options, { plugins = [] } = _a, rest = __objRest(_a, ["plugins"]);
    plugins.forEach((name) => {
      if (name === "geecaptcha") {
        this.plugins.push(new Geetest(rest));
      }
      if (name === "qqcaptcha") {
        this.plugins.push(new Qqcaptcha(rest));
      }
      if (name === "recaptcha") {
        this.plugins.push(new Recaptcha(rest));
      }
    });
  }
}
class BoneCaptcha {
  constructor(options) {
    __publicField(this, "currentIndex");
    __publicField(this, "captchas");
    __publicField(this, "lang");
    __publicField(this, "options");
    __publicField(this, "pluginLoader");
    this.currentIndex = 0;
    this.captchas = [];
    this.lang = options.lang || "en";
    this.options = options;
    this.pluginLoader = new PluginLoader(options);
    this.captchas = this.pluginLoader.plugins;
  }
  isCanResize() {
    const currentCaptcha = this.current();
    return currentCaptcha.key === "recaptcha";
  }
  resize(el) {
    const current = this.current();
    current.resize(el);
  }
  setLang(lang) {
    this.lang = lang;
    const current = this.current();
    current.setLang(lang);
  }
  initialize(options) {
    const currentCaptcha = this.current();
    if (currentCaptcha && currentCaptcha.initialize) {
      currentCaptcha.initialize(options);
    }
  }
  displayNext(options) {
    return __async(this, null, function* () {
      this.currentIndex += 1;
      return this.show(options);
    });
  }
  show(options) {
    return __async(this, null, function* () {
      const currentCaptcha = this.current();
      if (currentCaptcha) {
        try {
          const res = yield currentCaptcha.show(options);
          if (!res) {
            return this.displayNext(options);
          }
          if (isMobile()) {
            this.resize(options.id);
          }
          return {
            success: true,
            type: currentCaptcha.key
          };
        } catch (e) {
          console.warn(`[${currentCaptcha.key}] ${e}`);
          return this.displayNext(options);
        }
      } else {
        if (this.currentIndex === this.captchas.length) {
          this.reset();
        }
        return {
          success: false
        };
      }
    });
  }
  current() {
    return this.captchas[this.currentIndex];
  }
  refresh() {
    const current = this.current();
    if (current) {
      current.refresh();
    }
  }
  reset() {
    this.currentIndex = 0;
    this.refresh();
  }
  onMounted(options) {
    if (this.options.invisibleMode) {
      this.initialize(options);
    } else {
      this.show(options);
    }
  }
  onBeforeUnmount() {
    this.reset();
  }
}
const Captcha = ({
  invisibleMode,
  lang,
  plugins,
  onSuccess,
  onFail,
  onDisplay
}, ref) => {
  const [id, setId] = useState("captcha_" + parseInt(Math.random() * 1e5 + ""));
  const [captcha, setCaptcha] = useState();
  const callback = (res, cb) => {
    if (res.fallback) {
      captcha.displayNext({
        id,
        callback
      });
      return;
    }
    if (res.error) {
      reset();
      onDisplay == null ? void 0 : onDisplay(res);
    } else {
      onSuccess == null ? void 0 : onSuccess(res);
      cb == null ? void 0 : cb(res);
    }
  };
  useEffect(() => {
    let _plugins = plugins;
    if (window.location.host.includes("bybittr")) {
      if (_plugins.includes("qqcaptcha")) {
        _plugins.splice(_plugins.indexOf("qqcaptcha"), 1);
      }
    }
    const item = new BoneCaptcha({
      lang,
      geetStep1Request: registerGeetest,
      plugins: _plugins,
      invisibleMode,
      recaptchaSiteKey: RECAPTCHA_SITE_KEY,
      qqSiteKey: QQ_SITE_KEY
    });
    setCaptcha(item);
    item.onMounted({
      id,
      callback
    });
  }, []);
  const reset = () => {
    captcha.reset();
    onFail == null ? void 0 : onFail("reset");
  };
  const show = (cb) => __async(void 0, null, function* () {
    yield captcha.show({
      id,
      callback: (res) => {
        callback(res, cb);
      }
    });
  });
  useEffect(() => {
    if (!captcha)
      return;
    captcha.setLang(lang);
  }, [captcha, lang]);
  useImperativeHandle(ref, () => ({
    show,
    reset
  }));
  return /* @__PURE__ */ jsx("div", {
    id,
    style: {
      display: invisibleMode ? "none" : "block"
    }
  });
};
var Captcha$1 = forwardRef(Captcha);
const baseUrl = localStorage.getItem("testApi") || apiUrl;
const GET_USER_SECURITY = `${baseUrl}/v3/public/unbind-google-2fa/safety-items`;
const POST_SECURITY = `${baseUrl}/v3/public/unbind-google-2fa/commit`;
const SEND_SMS = `${baseUrl}/v3/public/unbind-google-2fa/send-code-to-mobile`;
const SEND_EMAIL = `${baseUrl}/v3/public/unbind-google-2fa/send-code-to-email`;
const EMAIL_TO_CUSTOMER = `${baseUrl}/v3/public/unbind-google-2fa/send-email-to-salesforce`;
function getUserSecurity(params) {
  return fetchData.get(GET_USER_SECURITY, {
    body: JSON.stringify(params)
  });
}
function postSecurity(params) {
  return new Promise((resolve, reject) => {
    fetchData.post(POST_SECURITY, {
      body: JSON.stringify(params)
    }).then((res) => {
      resolve(res);
    }).catch((error) => {
      reject(error.response ? error.response.data : error);
    });
  });
}
function sendSms(params) {
  return new Promise((resolve, reject) => {
    fetchData.post(SEND_SMS, {
      body: JSON.stringify(params)
    }).then((res) => {
      resolve(res);
    }).catch((error) => {
      reject(error.response ? error.response.data : error);
    });
  });
}
function sendEmail(params) {
  return new Promise((resolve, reject) => {
    fetchData.post(SEND_EMAIL, {
      body: JSON.stringify(params)
    }).then((res) => {
      resolve(res);
    }).catch((error) => {
      reject(error.response ? error.response.data : error);
    });
  });
}
function emailToCustomer(params) {
  return new Promise((resolve, reject) => {
    fetchData.post(EMAIL_TO_CUSTOMER, {
      body: JSON.stringify(params)
    }).then((res) => {
      resolve(res);
    }).catch((error) => {
      reject(error.response ? error.response.data : error);
    });
  });
}
const gaUnbindModel = "GaUnbindModal-module__gaUnbindModel___uPAeW";
const zInput = "GaUnbindModal-module__zInput___IHuT-";
const timeBtn = "GaUnbindModal-module__timeBtn___J001Q";
const errInput = "GaUnbindModal-module__errInput___Fc2Vj";
const disableWithdraw = "GaUnbindModal-module__disableWithdraw___-su5Q";
const disableWithdrawTxt = "GaUnbindModal-module__disableWithdrawTxt___zu61M";
const errTip$1 = "GaUnbindModal-module__errTip___rPuW-";
var styles$2 = {
  gaUnbindModel,
  zInput,
  timeBtn,
  errInput,
  disableWithdraw,
  disableWithdrawTxt,
  errTip: errTip$1
};
function CheckCircleOutLined() {
  return /* @__PURE__ */ jsxs("svg", {
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "4905",
    width: "20",
    height: "20",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M512 960C264.96 960 64 759.04 64 512S264.96 64 512 64s448 200.96 448 448S759.04 960 512 960zM512 128.288C300.416 128.288 128.288 300.416 128.288 512c0 211.552 172.128 383.712 383.712 383.712 211.552 0 383.712-172.16 383.712-383.712C895.712 300.416 723.552 128.288 512 128.288z",
      "p-id": "4906",
      fill: "#24AE64"
    }), /* @__PURE__ */ jsx("path", {
      d: "M726.976 393.184c-12.544-12.448-32.832-12.32-45.248 0.256l-233.28 235.84-103.264-106.112c-12.352-12.704-32.608-12.928-45.248-0.64-12.672 12.32-12.96 32.608-0.64 45.248l126.016 129.504c0.064 0.096 0.192 0.096 0.256 0.192 0.064 0.064 0.096 0.192 0.16 0.256 2.016 1.984 4.512 3.2 6.88 4.544 1.248 0.672 2.24 1.792 3.52 2.304 3.872 1.6 8 2.4 12.096 2.4 4.064 0 8.128-0.8 11.968-2.336 1.248-0.512 2.208-1.536 3.392-2.176 2.4-1.344 4.896-2.528 6.944-4.544 0.064-0.064 0.096-0.192 0.192-0.256 0.064-0.096 0.16-0.128 0.256-0.192l256.224-259.008C739.648 425.856 739.52 405.6 726.976 393.184z",
      "p-id": "4907",
      fill: "#24AE64"
    })]
  });
}
function ExclamationCircleOutlined() {
  return /* @__PURE__ */ jsxs("svg", {
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "5900",
    width: "20",
    height: "20",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M512 0C229.257143 0 0 229.257143 0 512s229.257143 512 512 512 512-229.257143 512-512S794.742857 0 512 0z m0 937.142857c-234.742857 0-425.142857-190.4-425.142857-425.142857s190.4-425.142857 425.142857-425.142857 425.142857 190.4 425.142857 425.142857-190.4 425.142857-425.142857 425.142857z",
      "p-id": "5901",
      fill: "#f7a600"
    }), /* @__PURE__ */ jsx("path", {
      d: "M457.142857 713.142857a54.857143 54.857143 0 1 0 109.714286 0 54.857143 54.857143 0 1 0-109.714286 0z m27.428572-128h54.857142c5.028571 0 9.142857-4.114286 9.142858-9.142857V265.142857c0-5.028571-4.114286-9.142857-9.142858-9.142857h-54.857142c-5.028571 0-9.142857 4.114286-9.142858 9.142857v310.857143c0 5.028571 4.114286 9.142857 9.142858 9.142857z",
      "p-id": "5902",
      fill: "#f7a600"
    })]
  });
}
var styles$1 = "";
const LoadingIcon = () => {
  return /* @__PURE__ */ jsx("svg", {
    viewBox: "0 0 1024 1024",
    focusable: "false",
    "data-icon": "loading",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    children: /* @__PURE__ */ jsx("path", {
      d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
    })
  });
};
function Button(props) {
  const _a = props, {
    children,
    type,
    className,
    htmlType,
    onClick
  } = _a, attr = __objRest(_a, [
    "children",
    "type",
    "className",
    "htmlType",
    "onClick"
  ]);
  const Type = (btnType) => {
    const buttonType = type ? type : "default";
    return buttonType.indexOf(btnType) != -1;
  };
  const isDisabled = Type("disabled") ? {
    disabled: true
  } : {};
  return /* @__PURE__ */ jsxs(Button$1, __spreadProps(__spreadValues(__spreadValues({
    variant: props.type
  }, attr), isDisabled), {
    type: htmlType ? htmlType : "button",
    onClick,
    className,
    children: [props.loading ? /* @__PURE__ */ jsx("span", {
      className: "by-security-cht-btn-loading-icon",
      children: /* @__PURE__ */ jsx("span", {
        role: "img",
        "aria-label": "loading",
        className: "anticon anticon-loading anticon-spin",
        children: /* @__PURE__ */ jsx(LoadingIcon, {})
      })
    }) : /* @__PURE__ */ jsx(Fragment, {}), /* @__PURE__ */ jsx("span", {
      children
    })]
  }));
}
function emailValidate(str) {
  const regs = /([\w\-]+\@[\w\-]+\.[\w\-]+)/;
  let obj = {
    msg: "",
    status: false
  };
  if (!regs.test(str)) {
    obj = {
      msg: "Invalid email address",
      status: false
    };
  } else {
    obj = {
      msg: "",
      status: true
    };
  }
  return obj;
}
const toCustomerModelContent = "toCustomerModel-module__toCustomerModelContent___-4n-i";
const modeInputContainer = "toCustomerModel-module__modeInputContainer___vw8EU";
const flexContainer = "toCustomerModel-module__flexContainer___l6z5M";
const iconContainer = "toCustomerModel-module__iconContainer___MOa-M";
const content = "toCustomerModel-module__content___R80Qx";
const title = "toCustomerModel-module__title___LoxfH";
const block = "toCustomerModel-module__block___h5C6R";
const lineContainer = "toCustomerModel-module__lineContainer___ZQfmh";
const errTip = "toCustomerModel-module__errTip___G3ViX";
var styles = {
  toCustomerModelContent,
  modeInputContainer,
  flexContainer,
  iconContainer,
  content,
  title,
  block,
  lineContainer,
  errTip
};
var index = "";
const ToCustomerModel = ({
  visible,
  setVisible,
  user,
  isPageMode
}) => {
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [mailError, setMailError] = useState("");
  const {
    $t,
    lang,
    reloadCallBack
  } = useStore();
  useEffect(() => {
    if (user.username && emailValidate(user.username + "")) {
      setEmail(user.username + "");
      setLoading(false);
    }
    if (user.vague_email && emailValidate(user.vague_email + "")) {
      setEmail(user.vague_email + "");
      setLoading(false);
    }
  }, [visible, lang]);
  const onCancelClick = () => {
    setVisible(false);
    cancel();
  };
  const cancel = () => {
    setEmail("");
    setLoading(false);
    setMailError("");
  };
  const onEmailChange = (e) => {
    setEmail(e.target.value);
    if (e.target.value) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  };
  const emailValidateF = (email2) => {
    const result = emailValidate(email2);
    if (!result.status) {
      setMailError($t("invalidMail"));
      return false;
    }
    setMailError("");
    return true;
  };
  const verify = () => {
    if (!user.username && !user.id)
      return;
    if (!emailValidateF(email)) {
      return;
    }
    setLoading(true);
    let params = {
      member_id: user.id,
      login_name: user.username,
      email,
      scene: 2
    };
    if (user.country_code) {
      params.country_code = user.country_code;
    }
    emailToCustomer(params).then((res) => {
      setLoading(false);
      if (res && res.ret_code === 0) {
        if (res.result.is_success === 0) {
          Toast({
            text: res.ret_code + ": " + res.ret_msg,
            duration: 3e3,
            position: "top",
            close: false,
            className: "by-security-auto-toast by-security-iconfont by-security-auto-toast--error"
          }).showToast();
        } else {
          const text = $t("SubmitSuccessfully") || "\u4E0A\u4F20\u6210\u529F";
          Toast({
            text,
            duration: 3e3,
            position: "top",
            close: false,
            className: "by-security-auto-toast by-security-iconfont by-security-auto-toast--success"
          }).showToast();
          setVisible();
          cancel();
          setTimeout(() => {
            reloadCallBack();
          }, 1500);
        }
      }
    }).catch((error) => {
      setLoading(false);
    });
  };
  const ByFooter = () => {
    return /* @__PURE__ */ jsx("div", {
      className: "flex",
      children: /* @__PURE__ */ jsx(Button, {
        type: "primary",
        disabled: loading,
        onClick: verify,
        children: $t("confirm", {
          ns: "common"
        })
      })
    });
  };
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(Modal, {
      zIndex: 10004,
      className: "security-component-modal",
      open: visible,
      onCancel: onCancelClick,
      title: $t("DGA"),
      footer: /* @__PURE__ */ jsx(ByFooter, {}),
      size: "small",
      children: /* @__PURE__ */ jsxs("div", {
        className: styles.toCustomerModelContent,
        children: [/* @__PURE__ */ jsxs("div", {
          className: styles.flexContainer,
          children: [/* @__PURE__ */ jsx("div", {
            className: styles.iconContainer,
            children: /* @__PURE__ */ jsx(CheckCircleOutLined, {})
          }), /* @__PURE__ */ jsx("div", {
            className: styles.content,
            children: /* @__PURE__ */ jsx("div", {
              className: classNames(styles.title, styles.block),
              children: $t("VerifySuccessfully")
            })
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: styles.lineContainer
        }), /* @__PURE__ */ jsxs("div", {
          className: styles.flexContainer,
          children: [/* @__PURE__ */ jsx("div", {
            className: styles.iconContainer,
            children: /* @__PURE__ */ jsx(ExclamationCircleOutlined, {})
          }), /* @__PURE__ */ jsxs("div", {
            className: styles.content,
            children: [/* @__PURE__ */ jsx("div", {
              className: styles.title,
              style: {
                margin: "9px 0px 10px",
                fontWeight: "400"
              },
              children: $t("EmailToCustomer")
            }), /* @__PURE__ */ jsx("div", {
              className: classNames(styles.inpContainer, {
                [styles.modeInputContainer]: !isPageMode
              }),
              children: /* @__PURE__ */ jsx("input", {
                className: "by-security-cht-input by-security-cht-inp",
                value: email,
                onChange: onEmailChange,
                placeholder: $t("EmailInputPlaceholder")
              })
            }), mailError !== "" && /* @__PURE__ */ jsx("div", {
              className: styles.errTip,
              children: mailError
            })]
          })]
        })]
      })
    })
  });
};
const KEY_VERSION = "v2";
const UnbindModel = ({
  visible,
  user,
  setVisible,
  onBindSuccess,
  closeModalHandler
}) => {
  const {
    lang,
    $t,
    reloadCallBack
  } = useStore();
  const divEl = useRef(null);
  const [loading, setLoading] = useState(false);
  const [phoneCode, setPhoneCode] = useState("");
  const [emailCode, setEmailCode] = useState("");
  const [phoneCodeErr, setPhoneCodeErr] = useState(false);
  const [emailCodeErr, setEmailCodeErr] = useState(false);
  const [hasEmail, setHasEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [hasPhone, setHasPhone] = useState(false);
  const [phone, setPhone] = useState("");
  const [workOrderType, setWorkOrderType] = useState("success");
  const [customerModel, setCustomerModel] = useState(true);
  const [eTimer, setETimer] = useState(null);
  const [eBegin, setEBegin] = useState(false);
  const [eSended, setESended] = useState(false);
  const [sTimer, setSTimer] = useState(null);
  const [sBegin, setSBegin] = useState(false);
  useEffect(() => {
    queryUserSecurity();
  }, [user]);
  useEffect(() => {
    if (hasEmail) {
      setLoading(!(phoneCode && emailCode));
    } else {
      setLoading(!phoneCode);
    }
  }, [phoneCode]);
  useEffect(() => {
    if (hasPhone) {
      setLoading(!(phoneCode && emailCode));
    } else {
      setLoading(!emailCode);
    }
  }, [emailCode]);
  const queryUserSecurity = () => {
    if (!user.id && !user.username)
      return;
    const params = {
      member_id: user.id,
      login_name: user.username
    };
    if (user.country_code) {
      params.country_code = user.country_code;
    }
    getUserSecurity(params).then((res) => {
      if (res && res.ret_code === 0) {
        if (res.result.vague_mobile) {
          setHasPhone(true);
          setPhone(res.result.vague_mobile);
        }
        if (res.result.vague_email) {
          setHasEmail(true);
          setEmail(res.result.vague_email);
        }
      }
    }).catch((error) => {
    });
  };
  const onCancelClick = (e) => {
    if (e)
      e.preventDefault();
    cancel();
  };
  const cancel = () => {
    setLoading(true);
    setPhoneCode("");
    setEmailCode("");
    setESended(false);
    setPhoneCodeErr(false);
    setEmailCodeErr(false);
    setVisible(false);
    closeModalHandler && closeModalHandler();
    if (eTimer) {
      closeInterval("email");
    }
    if (sTimer) {
      closeInterval("sms");
    }
  };
  const inputChange = (val, verify_type) => {
    if (verify_type === "email_verify") {
      setEmailCode(val);
      if (emailCodeErr) {
        setEmailCodeErr(false);
      }
    } else {
      setPhoneCode(val);
      if (phoneCodeErr) {
        setPhoneCodeErr(false);
      }
    }
  };
  const paramsValidate = () => {
    let res = false;
    if (hasEmail) {
      if (!emailCode || emailCode.length !== 6) {
        setEmailCodeErr(true);
        res = true;
      } else {
        setEmailCodeErr(false);
      }
    }
    if (hasPhone) {
      if (!phoneCode || phoneCode.length !== 6) {
        setPhoneCodeErr(true);
        res = true;
      } else {
        setPhoneCodeErr(false);
      }
    }
    return res;
  };
  const verify = () => {
    if (!user.id && !user.username)
      return;
    if (paramsValidate())
      return;
    const params = {
      member_id: user.id,
      login_name: user.username
    };
    if (user.country_code) {
      params.country_code = user.country_code;
    }
    if (hasEmail) {
      params.email_code = emailCode;
      params.email_from = 17;
    }
    if (hasPhone) {
      params.mobile_code = phoneCode;
      params.mobile_from = 16;
    }
    setLoading(true);
    postSecurity(params).then((res) => {
      setLoading(false);
      if (res && res.ret_code === 0) {
        if (res.result.is_manually_review === 0) {
          const msg = $t("UnbindSuccessfully") || "\u5173\u95ED\u6210\u529F";
          Toast({
            text: msg,
            duration: 3e3,
            position: "top",
            close: false,
            className: "by-security-auto-toast by-security-iconfont by-security-auto-toast--success"
          }).showToast();
          cancel();
          onBindSuccess == null ? void 0 : onBindSuccess();
          setTimeout(() => {
            reloadCallBack();
          }, 3e3);
        } else {
          setCustomerModel(true);
          setWorkOrderType("success");
          setLoading(true);
          setPhoneCode("");
          setEmailCode("");
          setESended(false);
          setPhoneCodeErr(false);
          setEmailCodeErr(false);
          if (eTimer) {
            closeInterval("email");
          }
          if (sTimer) {
            closeInterval("sms");
          }
        }
      }
    }).catch((error) => {
      setLoading(false);
      const data = error.data;
      if (data && data.ret_code === 20065) {
        setEmailCodeErr(true);
      } else if (data && data.ret_code === 20064) {
        setPhoneCodeErr(true);
      }
    });
  };
  const sendSmsClick = (cb) => {
    var _a;
    (_a = divEl == null ? void 0 : divEl.current) == null ? void 0 : _a.show((captchaData) => {
      sendSmsF(captchaData, cb);
    });
  };
  const sendSmsF = (captchaData, cb) => {
    if (!user.id && !user.username)
      return;
    const param = {
      member_id: user.id,
      login_name: user.username,
      from: 16
    };
    if (user.country_code) {
      param.country_code = user.country_code;
    }
    if (!captchaData.type) {
      captchaData.type = "geecaptcha";
    }
    if (!captchaData.key_version) {
      captchaData.key_version = KEY_VERSION;
    }
    const params = Object.assign(param, captchaData);
    sendSms(params).then((res) => {
      if (res && res.ret_code === 0) {
        cb();
      }
    }).catch((error) => {
    });
  };
  const sendEmailClick = (cb) => {
    if (!user.id && !user.username)
      return;
    const params = {
      member_id: user.id,
      login_name: user.username,
      key_version: KEY_VERSION,
      cnt: eSended ? 1 : 0,
      from: 17
    };
    if (user.country_code) {
      params.country_code = user.country_code;
    }
    sendEmail(params).then((res) => {
      if (res && res.ret_code === 0) {
        cb();
      } else if (res && res.ret_code === 20035) {
        Toast({
          text: "20035: over times",
          duration: 3e3,
          position: "top",
          close: false,
          className: "by-security-auto-toast by-security-iconfont by-security-auto-toast--error"
        }).showToast();
      } else
        ;
    }).catch((error) => {
    });
  };
  const closeInterval = (type) => {
    if (type === "email") {
      eTimer && clearInterval(eTimer);
      setETimer(null);
      setEBegin(false);
    } else {
      sTimer && clearInterval(sTimer);
      setSTimer(null);
      setSBegin(false);
    }
  };
  let plugins = ["geecaptcha", "qqcaptcha"];
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Modal, {
      zIndex: 10004,
      open: visible,
      onCancel: onCancelClick,
      title: $t("DGA"),
      className: "security-component-modal",
      footer: /* @__PURE__ */ jsx(Button$1, {
        className: "w-full",
        variant: "primary",
        disabled: loading,
        onClick: verify,
        children: $t("confirm", {
          ns: "common"
        })
      }),
      size: "small",
      children: /* @__PURE__ */ jsxs("div", {
        className: styles$2.gaUnbindModel,
        children: [/* @__PURE__ */ jsx("div", {
          className: styles$2.disableWithdraw,
          children: /* @__PURE__ */ jsx("div", {
            className: styles$2.disableWithdrawTxt,
            children: $t("unBindGaTip")
          })
        }), hasPhone ? /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx(WrapperComp$1, {
            verify: [{
              component_id: "phone_verify",
              component_extension: phone
            }],
            onPhoneResend: sendSmsClick,
            onInputChange: inputChange,
            isShowErrorName: phoneCodeErr
          }), /* @__PURE__ */ jsx(Captcha$1, {
            ref: divEl,
            plugins,
            lang,
            invisibleMode: true
          }), phoneCodeErr ? /* @__PURE__ */ jsx("div", {
            className: styles$2.errTip,
            children: $t("VerificationErrorTip")
          }) : ""]
        }) : "", hasEmail ? /* @__PURE__ */ jsxs("div", {
          style: {
            paddingTop: hasPhone ? "20px" : ""
          },
          children: [/* @__PURE__ */ jsx(WrapperComp$1, {
            verify: [{
              component_id: "email_verify",
              component_extension: email
            }],
            onEmailResend: sendEmailClick,
            onInputChange: inputChange,
            isShowErrorName: emailCodeErr
          }), emailCodeErr ? /* @__PURE__ */ jsx("div", {
            className: styles$2.errTip,
            children: $t("VerificationErrorTip") || "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u9A8C\u8BC1\u7801"
          }) : /* @__PURE__ */ jsx(Fragment, {})]
        }) : ""]
      })
    }), customerModel && /* @__PURE__ */ jsx(ToCustomerModel, {
      user,
      visible: customerModel,
      setVisible: () => {
        cancel();
      }
    })]
  });
};
const WrapperComp = (obj) => {
  if (!obj.isRoot) {
    return /* @__PURE__ */ jsx(UnbindModel, __spreadValues({}, obj));
  }
  return /* @__PURE__ */ jsx(GlobalProvider, {
    value: __spreadValues({}, obj),
    children: /* @__PURE__ */ jsx(UnbindModel, __spreadValues({}, obj))
  });
};
export { WrapperComp as GaUnBindModal, WrapperComp$1 as InputForSafety };
